import { useRootSelector } from "screens/Root/hooks/useAppSelector";
import { useResizeHandler } from "screens/Root/features/RightPanelFeatures/Resizer/useResizeHandler";
import { useEffect } from "react";
export const ResizerBackDrop = () => {
    useResizeHandler();
    const { isResizingActive } = useRootSelector();
    useEffect(() => { }, [isResizingActive]);
    return (<div className="backDrop" style={{
            zIndex: isResizingActive ? 10000000 : -10000000,
            position: "fixed",
            width: isResizingActive ? "100%" : 0,
            height: isResizingActive ? "100%" : 0,
        }}></div>);
};
